// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VoiceChatPage.css */

.voice-chat-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: 'Arial', sans-serif;
}

.voice-chat-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(15px);
  border-radius: 30px;
  padding: 60px 40px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  text-align: center;
  max-width: 600px;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.voice-chat-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2, #667eea);
  background-size: 200% 100%;
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
  0%, 100% {
    background-position: 200% 0;
  }
  50% {
    background-position: -200% 0;
  }
}

.voice-chat-title {
  color: #333;
  margin: 0 0 50px 0;
  font-size: 2.5em;
  font-weight: bold;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.voice-chat-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  margin: 50px 0;
  position: relative;
}

.voice-chat-footer {
  margin-top: 50px;
  padding-top: 30px;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}

.connection-status {
  font-size: 1.1em;
  font-weight: bold;
  margin: 0;
  padding: 12px 24px;
  border-radius: 25px;
  background: rgba(0, 0, 0, 0.05);
  color: #555;
  display: inline-block;
  min-width: 150px;
  transition: all 0.3s ease;
}

.connection-status:has-text("🟢") {
  background: linear-gradient(45deg, rgba(76, 175, 80, 0.1), rgba(129, 199, 132, 0.1));
  color: #2e7d32;
  border: 2px solid rgba(76, 175, 80, 0.3);
}

.connection-status:has-text("🔴") {
  background: linear-gradient(45deg, rgba(244, 67, 54, 0.1), rgba(239, 83, 80, 0.1));
  color: #c62828;
  border: 2px solid rgba(244, 67, 54, 0.3);
}

/* Decorative elements */
.voice-chat-content::before,
.voice-chat-content::after {
  content: '';
  position: absolute;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  z-index: -1;
  animation: float 6s ease-in-out infinite;
}

.voice-chat-content::before {
  top: -50px;
  left: -50px;
  animation-delay: 0s;
}

.voice-chat-content::after {
  bottom: -50px;
  right: -50px;
  animation-delay: 3s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) scale(1);
    opacity: 0.7;
  }
  50% {
    transform: translateY(-20px) scale(1.1);
    opacity: 0.3;
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .voice-chat-page {
    padding: 10px;
  }
  
  .voice-chat-container {
    padding: 40px 20px;
    border-radius: 20px;
  }
  
  .voice-chat-title {
    font-size: 2em;
    margin-bottom: 30px;
  }
  
  .voice-chat-content {
    margin: 30px 0;
  }
  
  .voice-chat-footer {
    margin-top: 30px;
  }
}

@media (max-width: 480px) {
  .voice-chat-title {
    font-size: 1.8em;
  }
  
  .connection-status {
    font-size: 1em;
    padding: 10px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./dist/src/components/pages/VoiceChatPage.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oFAAoF;EACpF,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kFAAkF;EAClF,cAAc;EACd,wCAAwC;AAC1C;;AAEA,wBAAwB;AACxB;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sFAAsF;EACtF,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,mCAAmC;IACnC,YAAY;EACd;EACA;IACE,uCAAuC;IACvC,YAAY;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;AACF","sourcesContent":["/* VoiceChatPage.css */\r\n\r\n.voice-chat-page {\r\n  min-height: 100vh;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  font-family: 'Arial', sans-serif;\r\n}\r\n\r\n.voice-chat-container {\r\n  background: rgba(255, 255, 255, 0.95);\r\n  backdrop-filter: blur(15px);\r\n  border-radius: 30px;\r\n  padding: 60px 40px;\r\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);\r\n  text-align: center;\r\n  max-width: 600px;\r\n  width: 100%;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.voice-chat-container::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 4px;\r\n  background: linear-gradient(90deg, #667eea, #764ba2, #667eea);\r\n  background-size: 200% 100%;\r\n  animation: shimmer 3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes shimmer {\r\n  0%, 100% {\r\n    background-position: 200% 0;\r\n  }\r\n  50% {\r\n    background-position: -200% 0;\r\n  }\r\n}\r\n\r\n.voice-chat-title {\r\n  color: #333;\r\n  margin: 0 0 50px 0;\r\n  font-size: 2.5em;\r\n  font-weight: bold;\r\n  background: linear-gradient(135deg, #667eea, #764ba2);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.voice-chat-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 30px;\r\n  margin: 50px 0;\r\n  position: relative;\r\n}\r\n\r\n.voice-chat-footer {\r\n  margin-top: 50px;\r\n  padding-top: 30px;\r\n  border-top: 2px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.connection-status {\r\n  font-size: 1.1em;\r\n  font-weight: bold;\r\n  margin: 0;\r\n  padding: 12px 24px;\r\n  border-radius: 25px;\r\n  background: rgba(0, 0, 0, 0.05);\r\n  color: #555;\r\n  display: inline-block;\r\n  min-width: 150px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.connection-status:has-text(\"🟢\") {\r\n  background: linear-gradient(45deg, rgba(76, 175, 80, 0.1), rgba(129, 199, 132, 0.1));\r\n  color: #2e7d32;\r\n  border: 2px solid rgba(76, 175, 80, 0.3);\r\n}\r\n\r\n.connection-status:has-text(\"🔴\") {\r\n  background: linear-gradient(45deg, rgba(244, 67, 54, 0.1), rgba(239, 83, 80, 0.1));\r\n  color: #c62828;\r\n  border: 2px solid rgba(244, 67, 54, 0.3);\r\n}\r\n\r\n/* Decorative elements */\r\n.voice-chat-content::before,\r\n.voice-chat-content::after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 100px;\r\n  height: 100px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));\r\n  z-index: -1;\r\n  animation: float 6s ease-in-out infinite;\r\n}\r\n\r\n.voice-chat-content::before {\r\n  top: -50px;\r\n  left: -50px;\r\n  animation-delay: 0s;\r\n}\r\n\r\n.voice-chat-content::after {\r\n  bottom: -50px;\r\n  right: -50px;\r\n  animation-delay: 3s;\r\n}\r\n\r\n@keyframes float {\r\n  0%, 100% {\r\n    transform: translateY(0px) scale(1);\r\n    opacity: 0.7;\r\n  }\r\n  50% {\r\n    transform: translateY(-20px) scale(1.1);\r\n    opacity: 0.3;\r\n  }\r\n}\r\n\r\n/* Responsive design */\r\n@media (max-width: 768px) {\r\n  .voice-chat-page {\r\n    padding: 10px;\r\n  }\r\n  \r\n  .voice-chat-container {\r\n    padding: 40px 20px;\r\n    border-radius: 20px;\r\n  }\r\n  \r\n  .voice-chat-title {\r\n    font-size: 2em;\r\n    margin-bottom: 30px;\r\n  }\r\n  \r\n  .voice-chat-content {\r\n    margin: 30px 0;\r\n  }\r\n  \r\n  .voice-chat-footer {\r\n    margin-top: 30px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .voice-chat-title {\r\n    font-size: 1.8em;\r\n  }\r\n  \r\n  .connection-status {\r\n    font-size: 1em;\r\n    padding: 10px 20px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
